import React from 'react';
import { Text } from '@fragments';
import { IconAlertTriangle, IconInfoCircle } from '@tabler/icons-react';
import './styles.scss';

// A state to act on: the account needs reconnecting, an automation is paused and why.
export default function Notice({ tone = 'alert', icon, title, text, action, className = '' }) {
  const Glyph = tone === 'alert' ? IconAlertTriangle : IconInfoCircle;
  return <div className={`studio-automation-notice is-${tone} ${className}`.trim()} role={tone === 'alert' ? 'alert' : 'status'}>
    <span className="studio-automation-notice__icon" aria-hidden="true">{icon || <Glyph />}</span>
    <div className="studio-automation-notice__text">
      {title && <Text.label contrast={9}>{title}</Text.label>}
      {text && <Text.span contrast={7}>{text}</Text.span>}
    </div>
    {action && <div className="studio-automation-notice__action">{action}</div>}
  </div>;
}
